import { DO_LOOKUP, DO_LOOKUP_ERROR, RECEIVE_LOOKUP } from '../actions/lookup';

const reducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case DO_LOOKUP:
    case DO_LOOKUP_ERROR:
      return { ...state };

    case RECEIVE_LOOKUP:
      return { ...state, ...payload };

    case 'lookup/managers':
      return { ...state, managers: [...(action.payload || [])] };

    default:
      return { ...state };
  }
};
export default reducer;